<template>
  <div class="page-not-found-container">
    <h2 class="not-found-message">
      404: The page you are looking for does not exist
    </h2>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.not-found-message {
  font-size: 30px;
  margin-top: 40px;
}
</style>